import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../store/Store'
import {IOrganizationDto} from './Organization.model'
import {organizationApi} from './Organization.api'

type InitialState = {
  organization: {
    data: IOrganizationDto | undefined
    loading: boolean
    error: string | undefined
  }
}
const initialState = {
  organization: {
    data: undefined,
    loading: false,
    error: undefined,
  }
} as InitialState
export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addMatcher(organizationApi.endpoints.getOrganizationById.matchPending, (state) => {
        state.organization = {
          ...initialState.organization,
          loading: true,
          error: undefined,
        }
      })
      .addMatcher(organizationApi.endpoints.getOrganizationById.matchFulfilled, (state, action) => {
        state.organization = {
          data: action.payload,
          loading: false,
          error: undefined,
        }
      })
      .addMatcher(organizationApi.endpoints.getOrganizationById.matchRejected, (state) => {
        state.organization = {
          ...initialState.organization,
          loading: false,
          error: 'Undefined error <TODO>',
        }
      })
  },
})

export default organizationSlice.reducer

export const selectOrganization = (state: RootState) => state.organizationReducer.organization.data
export const selectOrganizationLoading = (state: RootState) => state.organizationReducer.organization.loading
export const selectOrganizationError = (state: RootState) => state.organizationReducer.organization.error
